module.exports = __webpack_public_path__ + "assets-cabinet/img/arrow-diag.146afdc1.svg";